const upSellSlider = (data) => {
    const sliderContainers = document.querySelectorAll('.mini-cart_upsell');
    const breakpoints = [];
    window.addEventListener('resize', (e) => {
        setWidth();
        beforeScreenWidth = screen.availWidth;
    });
    document.addEventListener('mouseup',()=>{
        document.querySelectorAll('.mini-cart_upsell .scrollbar-thumb').forEach(item=>{
            item.removeAttribute('focus');
            item.removeAttribute('x');
        });
    });
    document.addEventListener('mousemove',(e)=>{
        const focusedScrollThumb = document.querySelector('.mini-cart_upsell .scrollbar-thumb[focus="2"]');
        if(focusedScrollThumb) {
            let x = parseInt(focusedScrollThumb.getAttribute('x'));
            const left = e.clientX;
            if(!isNaN(x)) {
                const move_distance = left - x;
                const sliderContainer = focusedScrollThumb.closest('.mini-cart_upsell');
                const sliderWrapper = sliderContainer.querySelector('.mini-cart_upsell-carousel');
                const restWidth = sliderWrapper.scrollWidth - sliderContainer.offsetWidth;
                const restScrollWidth = sliderContainer.offsetWidth - focusedScrollThumb.offsetWidth;
                const ratio = restWidth / restScrollWidth;
                sliderWrapper.scrollBy({
                    left: move_distance * ratio
                });
            }
            focusedScrollThumb.setAttribute('x', left);
        }
    });
    const setWidth = () => {
        const cartDrawer = document.querySelector('#cart-drawer');
        if (getComputedStyle(cartDrawer).display == 'none') {
            cartDrawer.classList.add('show_moment');
        }
        const gap_count = getCount_Gap();
        sliderContainers.forEach(sliderContainer => {
            setSliderContainerMaxWidth(sliderContainer);
            const sliderWrapper = sliderContainer.querySelector('.mini-cart_upsell-carousel');
            const sliderScrollbar = sliderContainer.querySelector('.scrollbar-thumb');
            if(sliderScrollbar) {
                const restWidth = sliderWrapper.scrollWidth - sliderContainer.offsetWidth;
                const restScrollWidth = sliderContainer.offsetWidth - sliderScrollbar.offsetWidth;
                const ratio = restScrollWidth / restWidth;
                const move_distance = sliderWrapper.scrollLeft * ratio;
                sliderScrollbar.style.width = sliderContainer.offsetWidth / (sliderWrapper.scrollWidth / sliderContainer.offsetWidth) - 18 + 'px';
                sliderScrollbar.style.left = move_distance + 'px';
            }

            const sliderItems = sliderWrapper.querySelectorAll('.mini-cart_upsell-item');

            const width = sliderContainer.offsetWidth / gap_count.slidesCountPerView - gap_count.gap;

            sliderItems.forEach((sliderItem, index) => {
                sliderItem.style.width = width + 'px';
                if(index + 1 < sliderItems.length) {
                    sliderItem.style.marginRight = gap_count.gap + 'px';
                }
            });
        });
        cartDrawer.classList.remove('show_moment');
    }
    
    const setRTLWidth = () => {
        const cartDrawer = document.querySelector('#cart-drawer');
        if (getComputedStyle(cartDrawer).display == 'none') {
            cartDrawer.classList.add('show_moment');
        }
        const gap_count = getCount_Gap();
        sliderContainers.forEach(sliderContainer => {
            setSliderContainerMaxWidth(sliderContainer);
            const sliderWrapper = sliderContainer.querySelector('.mini-cart_upsell-carousel');
            const sliderScrollbar = sliderContainer.querySelector('.scrollbar-thumb');
            if(sliderScrollbar) {
                const restWidth = sliderWrapper.scrollWidth - sliderContainer.offsetWidth;
                const restScrollWidth = sliderContainer.offsetWidth - sliderScrollbar.offsetWidth;
                const ratio = restScrollWidth / restWidth;
                const move_distance = sliderWrapper.scrollRight * ratio;
                sliderScrollbar.style.width = sliderContainer.offsetWidth / (sliderWrapper.scrollWidth / sliderContainer.offsetWidth) - 18 + 'px';
                sliderScrollbar.style.right = move_distance + 'px';
            }

            const sliderItems = sliderWrapper.querySelectorAll('.mini-cart_upsell-item');

            const width = sliderContainer.offsetWidth / gap_count.slidesCountPerView - gap_count.gap;

            sliderItems.forEach((sliderItem, index) => {
                sliderItem.style.width = width + 'px';
                if(index + 1 < sliderItems.length) {
                    sliderItem.style.marginLeft = gap_count.gap + 'px';
                }
            });
        });
        cartDrawer.classList.remove('show_moment');
    }
    const getWidth = (data) => {
        let w = 0;
        for (const key in data.breakpoints) {
            w = parseInt(key);
            if (breakpoints.length === 0) {
                breakpoints.push({
                    width: w,
                    ...data.breakpoints[key]
                });
            } else {
                let isInserted = false;
                for (const [index, breakpoint] of breakpoints.entries()) {
                    if (breakpoint.width > w) {
                        if (index === 0) {
                            breakpoints.unshift({
                                width: w,
                                ...data.breakpoints[key]
                            });
                        } else {
                            breakpoints.splice(index - 1, 0, {
                                width: w,
                                ...data.breakpoints[key]
                            });
                        }
                        isInserted = true;
                    } else if (breakpoint.width === w) {
                        break;
                    }
                }
                if (!isInserted) {
                    breakpoints.push({
                        width: w,
                        ...data.breakpoints[key]
                    });
                }
            }
        }
    }
    const getRTLWidth = (data) => {
        let w = 0;
        for (const key in data.breakpoints) {
            w = parseInt(key);
            if (breakpoints.length === 0) {
                breakpoints.push({
                    width: w,
                    ...data.breakpoints[key]
                });
            } else {
                let isInserted = false;
                for (const [index, breakpoint] of breakpoints.entries()) {
                    if (breakpoint.width > w) {
                        if (index === 0) {
                            breakpoints.unshift({
                                width: w,
                                ...data.breakpoints[key]
                            });
                        } else {
                            breakpoints.splice(index - 1, 0, {
                                width: w,
                                ...data.breakpoints[key]
                            });
                        }
                        isInserted = true;
                    } else if (breakpoint.width === w) {
                        break;
                    }
                }
                if (!isInserted) {
                    breakpoints.push({
                        width: w,
                        ...data.breakpoints[key]
                    });
                }
            }
        }
    }
    const getCount_Gap = () => {
        let before_w = {};
        for (const breakpoint of breakpoints) {
            if (breakpoint.width > document.body.offsetWidth) {
                break;
            } else {
                if (typeof breakpoint.gap == 'number' && breakpoint.gap >= 0) {
                    before_w['gap'] = breakpoint.gap;
                }
                if (typeof breakpoint.slidesCountPerView == 'number' && breakpoint.slidesCountPerView > 0) {
                    before_w['slidesCountPerView'] = breakpoint.slidesCountPerView;
                }
            }
        }
        if (typeof before_w.gap != 'number') {
            if (typeof data.gap == 'number' && data.gap >= 0) {
                before_w['gap'] = data.gap;
            } else {
                before_w['gap'] = 10;
            }
        }
        if (typeof before_w.slidesCountPerView != 'number') {
            if (typeof data.slidesCountPerView == 'number' && data.slidesCountPerView > 0) {
                before_w['slidesCountPerView'] = data.slidesCountPerView;
            } else {
                before_w['slidesCountPerView'] = 2.5;
            }
        }
        return before_w;
    }
    const createScrollBar = () => {
        sliderContainers.forEach(sliderContainer => {
            if(sliderContainer.querySelector('.scrollbar-thumb')) {
                return;
            }
            const cartDrawer = document.querySelector('#cart-drawer');
            if (getComputedStyle(cartDrawer).display == 'none') {
                cartDrawer.classList.add('show_moment');
            }
            const sliderWrapper = sliderContainer.querySelector('.mini-cart_upsell-carousel');
            if(sliderWrapper.scrollWidth > sliderContainer.offsetWidth) {
                const scrollbarTrack = document.createElement('div');
                const scrollbarThumb = document.createElement('div');
                scrollbarTrack.classList.add('scrollbar-track');
                scrollbarThumb.classList.add('scrollbar-thumb');
                sliderContainer.insertBefore(scrollbarTrack,sliderWrapper);
                scrollbarTrack.appendChild(scrollbarThumb);
                scrollbarThumb.style.width = sliderContainer.offsetWidth / (sliderWrapper.scrollWidth / sliderContainer.offsetWidth) - 18 + 'px';
                sliderWrapper.addEventListener('scroll',(e)=>{
                    const thumb = sliderWrapper.closest('.mini-cart_upsell').querySelector('.scrollbar-thumb');
                    const restWidth = sliderWrapper.scrollWidth - sliderContainer.offsetWidth;
                    const restScrollWidth = sliderContainer.offsetWidth - thumb.offsetWidth;
                    const ratio = restScrollWidth / restWidth;
                    const move_distance = sliderWrapper.scrollLeft * ratio;
                    if(thumb.offsetWidth + move_distance >= sliderContainer.offsetWidth) {
                        thumb.style.left = sliderContainer.offsetWidth - thumb.offsetWidth + 'px';
                    } else {
                        thumb.style.left = move_distance + 'px';
                    }
                });
                scrollbarThumb.addEventListener('mousemove',(e)=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(!focusState) {
                        scrollbarThumb.setAttribute('focus',1);
                    }
                });
                scrollbarThumb.addEventListener('mousedown',()=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(focusState === '1') {
                        scrollbarThumb.setAttribute('focus', 2);
                    }
                });
                scrollbarThumb.addEventListener('mouseout',()=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(focusState !== '2') {
                        scrollbarThumb.removeAttribute('focus');
                    }
                });
                scrollbarThumb.addEventListener('mouseup',()=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(focusState === '1') {
                        scrollbarThumb.setAttribute('focus', -1);
                    } else if(focusState === '2') {
                        scrollbarThumb.removeAttribute('focus');
                    }
                });
            }
            cartDrawer.classList.remove('show_moment');
        });
    }
    const createRTLScrollBar = () => {
        sliderContainers.forEach(sliderContainer => {
            if(sliderContainer.querySelector('.scrollbar-thumb')) {
                return;
            }
            const cartDrawer = document.querySelector('#cart-drawer');
            if (getComputedStyle(cartDrawer).display == 'none') {
                cartDrawer.classList.add('show_moment'); 
            }
            const sliderWrapper = sliderContainer.querySelector('.mini-cart_upsell-carousel');
            if(sliderWrapper.scrollWidth > sliderContainer.offsetWidth) {
                const scrollbarTrack = document.createElement('div');
                const scrollbarThumb = document.createElement('div');
                scrollbarTrack.classList.add('scrollbar-track');
                scrollbarThumb.classList.add('scrollbar-thumb'); 
                sliderContainer.insertBefore(scrollbarTrack,sliderWrapper);
                scrollbarTrack.appendChild(scrollbarThumb);
                scrollbarThumb.style.width = sliderContainer.offsetWidth / (sliderWrapper.scrollWidth / sliderContainer.offsetWidth) - 18 + 'px';
                sliderWrapper.addEventListener('scroll',(e)=>{
                    const thumb = sliderWrapper.closest('.mini-cart_upsell').querySelector('.scrollbar-thumb');
                    const restWidth = sliderWrapper.scrollWidth - sliderContainer.offsetWidth;
                    const restScrollWidth = sliderContainer.offsetWidth - thumb.offsetWidth;
                    const ratio = restScrollWidth / restWidth;
                    const move_distance = sliderWrapper.scrollLeft * ratio;
                    if(thumb.offsetWidth + move_distance >= sliderContainer.offsetWidth) {
                        thumb.style.right = sliderContainer.offsetWidth - thumb.offsetWidth + 'px';
                    } else {
                        thumb.style.right = Math.abs(move_distance) + 'px';
                    }
                });
                scrollbarThumb.addEventListener('mousemove',(e)=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(!focusState) {
                        scrollbarThumb.setAttribute('focus',1);
                    }
                });
                scrollbarThumb.addEventListener('mousedown',()=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(focusState === '1') {
                        scrollbarThumb.setAttribute('focus', 2);
                    }
                });
                scrollbarThumb.addEventListener('mouseout',()=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(focusState !== '2') {
                        scrollbarThumb.removeAttribute('focus');
                    }
                });
                scrollbarThumb.addEventListener('mouseup',()=>{
                    const focusState = scrollbarThumb.getAttribute('focus');
                    if(focusState === '1') {
                        scrollbarThumb.setAttribute('focus', -1);
                    } else if(focusState === '2') {
                        scrollbarThumb.removeAttribute('focus');
                    }
                });
            }
            cartDrawer.classList.remove('show_moment');
        });
    }
    if(document.querySelector('html').getAttribute('dir') == 'rtl'){
        getRTLWidth(data);
        createRTLScrollBar()
        setRTLWidth();
    }else {
        getWidth(data);
        createScrollBar();
        setWidth();
    }
};
const setSliderContainerMaxWidth = (sliderContainer) => {
    if(sliderContainer) {
        const originalElement = document.querySelector('.cart-drawer').shadowRoot.querySelector('[part=body]');
        if(originalElement) {
            const sPaddingLeft = getComputedStyle(originalElement).paddingLeft;
            const paddingLeft = parseInt(sPaddingLeft.substring(0, sPaddingLeft.length - 2));
            sliderContainer.style.maxWidth = `${originalElement.offsetWidth - paddingLeft * 2}px`;
        }
    }
}